(function () {
  var faqButtons = document.querySelectorAll(".faq-question");
  var appointmentEndpoint =
    "https://script.google.com/macros/s/AKfycbxCZgrLspiVkJuUejHPUJunaYW9Meplc5IZNb-PH-DBpJHovpUbD4gigDfiDQn0-zv7Vw/exec";
  var legacyGclidEndpoint =
    "https://script.google.com/macros/s/AKfycbyf8ZptUDblAcFd_qH89SS59J7FaFqRoDLV1T7DpYuu75ow8KSDtmySQIbdj8zOwW_S0w/exec";
  var legacyGclidDedupWindowMs = 120000;
  var legacyGclidSignalsSentAt = {};
  var trackingParamNames = ["gclid", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
  var trackingStoragePrefix = "suitailor_";
  var isDevelopment =
    window.location.protocol === "file:" ||
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  function getUrlParam(name) {
    return new URLSearchParams(window.location.search).get(name) || "";
  }

  function getStoredParam(name) {
    try {
      return window.localStorage.getItem(trackingStoragePrefix + name) || "";
    } catch (error) {
      return "";
    }
  }

  function storeTrackingParams() {
    trackingParamNames.forEach(function (name) {
      var value = getUrlParam(name);

      if (!value) {
        return;
      }

      try {
        window.localStorage.setItem(trackingStoragePrefix + name, value);
      } catch (error) {
        if (isDevelopment) {
          console.warn("No se pudo guardar el parámetro de tracking", name, error);
        }
      }
    });
  }

  function getTrackingValue(name) {
    return getUrlParam(name) || getStoredParam(name);
  }

  function getLandingValue() {
    var landingInput = document.querySelector('input[name="landing"]');
    return landingInput ? landingInput.value : "";
  }

  function getPageType() {
    var landing = getLandingValue();
    var pageTypesByLanding = {
      "trajes-a-medida-las-rozas": "trajes_a_medida",
      "alquiler-chaque-madrid": "alquiler_chaque",
    };

    return pageTypesByLanding[landing] || "trajes_a_medida";
  }

  function padDatePart(value) {
    return String(value).padStart(2, "0");
  }

  function formatLegacyGclidTimestamp(date) {
    return (
      date.getFullYear() +
      "-" +
      padDatePart(date.getMonth() + 1) +
      "-" +
      padDatePart(date.getDate()) +
      " " +
      padDatePart(date.getHours()) +
      ":" +
      padDatePart(date.getMinutes()) +
      ":" +
      padDatePart(date.getSeconds())
    );
  }

  function getLegacyGclidSignalKey(gclid, source) {
    return trackingStoragePrefix + "legacy_gclid_signal_" + getLandingValue() + "_" + source + "_" + gclid;
  }

  function getLegacyGclidSignalSentAt(key) {
    try {
      return Number(window.sessionStorage.getItem(key)) || legacyGclidSignalsSentAt[key] || 0;
    } catch (error) {
      return legacyGclidSignalsSentAt[key] || 0;
    }
  }

  function markLegacyGclidSignalSent(key) {
    var sentAt = Date.now();
    legacyGclidSignalsSentAt[key] = sentAt;

    try {
      window.sessionStorage.setItem(key, String(sentAt));
    } catch (error) {
      if (isDevelopment) {
        console.warn("No se pudo guardar la marca de GCLID legado", error);
      }
    }
  }

  function wasLegacyGclidSignalSentRecently(key) {
    var sentAt = getLegacyGclidSignalSentAt(key);
    return sentAt && Date.now() - sentAt < legacyGclidDedupWindowMs;
  }

  function isWhatsAppLink(element) {
    var href = element.getAttribute("href") || "";

    return /^https?:\/\/(wa\.me|(?:api\.)?whatsapp\.com)\b/i.test(href);
  }

  function submitLegacyGclidSignal(source) {
    var gclid = getTrackingValue("gclid");

    if (!gclid) {
      return;
    }

    var signalKey = getLegacyGclidSignalKey(gclid, source);

    if (wasLegacyGclidSignalSentRecently(signalKey)) {
      return;
    }

    markLegacyGclidSignalSent(signalKey);

    var payload = new URLSearchParams();
    payload.set("gclid", gclid);
    payload.set("timestamp", formatLegacyGclidTimestamp(new Date()));
    payload.set("source", source);

    fetch(legacyGclidEndpoint + "?" + payload.toString(), {
      method: "GET",
      mode: "no-cors",
      keepalive: true,
    }).catch(function (error) {
      if (isDevelopment) {
        console.warn("No se pudo enviar la señal secundaria de GCLID", error);
      }
    });
  }

  storeTrackingParams();

  faqButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      var answerId = button.getAttribute("aria-controls");
      var answer = document.getElementById(answerId);
      var isExpanded = button.getAttribute("aria-expanded") === "true";

      button.setAttribute("aria-expanded", String(!isExpanded));

      if (answer) {
        answer.hidden = isExpanded;
      }
    });
  });

  var ctaElements = document.querySelectorAll("[data-cta-name]");

  ctaElements.forEach(function (element) {
    element.addEventListener("click", function () {
      var ctaName = element.getAttribute("data-cta-name");
      var ctaLocation = element.getAttribute("data-cta-location");
      var ctaType = element.getAttribute("data-cta");
      var ctaSection = element.getAttribute("data-section");

      window.dataLayer = window.dataLayer || [];

      var eventPayload = {
        event: "landing_trajes_cta_click",
        cta_name: ctaName,
        cta_location: ctaLocation,
        cta_type: ctaType,
        cta_section: ctaSection,
        page_type: getPageType(),
        traffic_context: "google_ads",
      };

      window.dataLayer.push(eventPayload);

      if (isWhatsAppLink(element)) {
        submitLegacyGclidSignal("whatsapp_send_click");
      }

      if (isDevelopment) {
        console.log("landing_trajes_cta_click", eventPayload);
      }
    });
  });

  var appointmentForm = document.querySelector('[data-form-name="solicitud_cita"]');

  if (appointmentForm) {
    var dateInput = appointmentForm.querySelector("#fecha-preferida");
    var dayInput = appointmentForm.querySelector("#dia-preferido");
    var timeSelect = appointmentForm.querySelector("#hora-preferida");
    var appointmentSummary = appointmentForm.querySelector("[data-appointment-summary]");
    var privacyConsent = appointmentForm.querySelector('[data-field="privacy-consent"]');
    var privacyError = appointmentForm.querySelector("[data-privacy-error]");
    var privacyConsentMessage = "Debes aceptar la Política de Privacidad para enviar tu solicitud.";
    var today = new Date();

    today.setHours(0, 0, 0, 0);

    function formatDateForInput(date) {
      var month = String(date.getMonth() + 1).padStart(2, "0");
      var day = String(date.getDate()).padStart(2, "0");

      return date.getFullYear() + "-" + month + "-" + day;
    }

    function parseInputDate(value) {
      if (!value) {
        return null;
      }

      var parts = value.split("-");
      var year = Number(parts[0]);
      var month = Number(parts[1]);
      var day = Number(parts[2]);

      if (!year || !month || !day) {
        return null;
      }

      return new Date(year, month - 1, day);
    }

    function formatWeekday(date) {
      return new Intl.DateTimeFormat("es-ES", { weekday: "long" }).format(date);
    }

    function formatReadableDate(date) {
      return new Intl.DateTimeFormat("es-ES", {
        day: "numeric",
        month: "long",
      }).format(date);
    }

    function updateAppointmentSummary() {
      if (!appointmentSummary) {
        return;
      }

      var selectedDate = parseInputDate(dateInput && dateInput.value);
      var selectedTime = timeSelect && timeSelect.value;

      if (!selectedDate || selectedDate < today || !selectedTime) {
        appointmentSummary.textContent = "Selecciona fecha y hora dentro del horario de atención.";
        return;
      }

      appointmentSummary.textContent =
        "Solicitud para " +
        formatWeekday(selectedDate) +
        ", " +
        formatReadableDate(selectedDate) +
        " a las " +
        selectedTime;
    }

    function updateSelectedDay() {
      if (!dateInput || !dayInput) {
        return;
      }

      var selectedDate = parseInputDate(dateInput.value);

      if (!selectedDate) {
        dayInput.value = "Selecciona una fecha";
        dateInput.setCustomValidity("");
        updateAppointmentSummary();
        return;
      }

      if (selectedDate < today) {
        dayInput.value = "Selecciona una fecha";
        dateInput.setCustomValidity("Selecciona una fecha actual o futura.");
        updateAppointmentSummary();
        return;
      }

      dayInput.value = formatWeekday(selectedDate);
      dateInput.setCustomValidity("");
      updateAppointmentSummary();
    }

    if (dateInput) {
      dateInput.min = formatDateForInput(today);
      dateInput.addEventListener("input", updateSelectedDay);
      dateInput.addEventListener("change", updateSelectedDay);
    }

    if (timeSelect) {
      timeSelect.addEventListener("change", updateAppointmentSummary);
    }

    function validatePrivacyConsent(showError) {
      if (!privacyConsent) {
        return true;
      }

      var isAccepted = privacyConsent.checked;
      privacyConsent.setCustomValidity(isAccepted ? "" : privacyConsentMessage);

      if (privacyError) {
        privacyError.textContent = !isAccepted && showError ? privacyConsentMessage : "";
      }

      return isAccepted;
    }

    function buildLeadPayload() {
      var formData = new FormData(appointmentForm);
      var payload = new URLSearchParams();

      formData.forEach(function (value, key) {
        payload.append(key, value);
      });

      payload.set("fecha_evento", (dateInput && dateInput.value) || payload.get("fecha_preferida") || "");
      payload.set("page_url", window.location.href);
      payload.set("user_agent", navigator.userAgent);

      trackingParamNames.forEach(function (name) {
        payload.set(name, getTrackingValue(name));
      });

      return payload;
    }

    function submitLead(payload) {
      return fetch(appointmentEndpoint, {
        method: "POST",
        mode: "no-cors",
        body: payload,
        keepalive: true,
      });
    }

    if (privacyConsent) {
      privacyConsent.addEventListener("change", function () {
        validatePrivacyConsent(false);
      });
      privacyConsent.addEventListener("invalid", function () {
        validatePrivacyConsent(true);
      });
      validatePrivacyConsent(false);
    }

    updateSelectedDay();

    appointmentForm.addEventListener("submit", function (event) {
      event.preventDefault();
      updateSelectedDay();
      validatePrivacyConsent(true);

      if (!appointmentForm.checkValidity()) {
        appointmentForm.reportValidity();
        return;
      }

      var status = appointmentForm.querySelector("[data-form-status]");
      var submitButton = appointmentForm.querySelector('button[type="submit"]');
      var leadPayload = buildLeadPayload();

      if (submitButton) {
        submitButton.disabled = true;
      }

      if (status) {
        status.textContent = "Enviando solicitud...";
      }

      window.dataLayer = window.dataLayer || [];

      var submitPayload = {
        event: "submit_solicitud_cita",
        page_type: getPageType(),
        traffic_context: "google_ads",
        form_location: "solicitar_cita",
        cta_type: "reservar-cita",
        cta_section: "reserva",
      };

      window.dataLayer.push(submitPayload);

      if (isDevelopment) {
        console.log("submit_solicitud_cita", submitPayload);
      }

      submitLead(leadPayload)
        .then(function () {
          submitLegacyGclidSignal("form_submit");

          if (status) {
            status.textContent = "Solicitud enviada correctamente. Te contactaremos para gestionar tu cita.";
          }
        })
        .catch(function (error) {
          if (status) {
            status.textContent = "No se pudo enviar la solicitud. Inténtalo de nuevo en unos segundos.";
          }

          if (isDevelopment) {
            console.error("Error al enviar la solicitud", error);
          }
        })
        .finally(function () {
          if (submitButton) {
            submitButton.disabled = false;
          }
        });
    });
  }
})();
